// removed by extract-text-webpack-plugin
module.exports = {"toggle":"Xd_SiTmZf96OOVJeNApNm","button":"_3ndNiiWIEcXnj7jiNYZwEG","checked":"_3BnnHpqiHmCvjuQKuIvNGd","invisibleButton":"_1XENDbwmEw4NVTZuUZRtKa","labels":"_3jJBg5s8nF-1_XDI7O0k6C","label":"_3um01aOHaq-UxEawvBkt1p"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/toggleButton.css
// module id = 680
// module chunks = 0